import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, Button, Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import PageWrapper from '../PageWrapper';
import { getSolutionsSectionData } from '../../../services/homepage';
import SEO from '../../common/SEO';

const SolutionsHub = () => {
    const pillars = [
        { title: 'Venta', icon: '/assets/nosotros/icon venta.png', desc: 'Motores de reserva optimizados para conversión.' },
        { title: 'Operación', icon: '/assets/nosotros/icon operacion.png', desc: 'Gestión eficiente de reservas y post-venta.' },
        { title: 'Distribución', icon: '/assets/nosotros/icon distribucion.png', desc: 'Conectividad total con GDS y NDC.' },
        { title: 'Optimización', icon: '/assets/nosotros/icon optimizacion.png', desc: 'Mejora continua basada en datos e IA.' },
    ];

    const getLocalIcon = (title) => {
        const t = title.toLowerCase();
        if (t.includes('aéreo')) return '/assets/nosotros/vertical aereos.png';
        if (t.includes('hotel')) return '/assets/nosotros/vertical hoteles.png';
        if (t.includes('tren')) return '/assets/nosotros/vertical tren.png';
        if (t.includes('asistencia')) return '/assets/nosotros/vertical asistencia.png';
        if (t.includes('circuito')) return '/assets/nosotros/vertical circuito.png';
        return null;
    };

    return (
        <PageWrapper
            fetchData={getSolutionsSectionData}
            render={(data) => {
                if (!data) return null;
                const items = data.solutions_section_items || [];

                return (
                    <Box sx={{ bgcolor: '#fbfcfd' }}>
                        <SEO 
                            title="Soluciones | Motores de reservas y tecnología B2B para turismo — E2E"
                            description="Explora nuestras soluciones: Aéreos, Hoteles y Discovery Tecnológico. Tecnología modular para empresas de turismo, con foco en eficiencia y conversión."
                        />
                        
                        {/* Hero Section */}
                        <Box sx={{ py: { xs: 8, md: 10 }, bgcolor: '#eff2f9', textAlign: 'center' }}>
                            <Container maxWidth="lg">
                                <Typography variant="h1" sx={{ mb: 3, fontWeight: 800, color: '#4e429c', fontSize: { xs: '2.5rem', md: '3.5rem' } }}>
                                    Soluciones tecnológicas para vender y operar viajes
                                </Typography>
                                <Typography variant="h6" sx={{ color: '#666', maxWidth: '800px', mx: 'auto', lineHeight: 1.6 }}>
                                    Tecnología modular y escalable diseñada para potenciar cada área de tu negocio turístico.
                                </Typography>
                            </Container>
                        </Box>

                        {/* Pillars Section */}
                        <Container maxWidth="lg" sx={{ mt: -5, mb: 10 }}>
                            <Grid container spacing={3}>
                                {pillars.map((pillar, idx) => (
                                    <Grid item xs={12} sm={6} md={3} key={idx}>
                                        <Paper sx={{ p: 3, textAlign: 'center', borderRadius: 4, boxShadow: '0 10px 30px rgba(0,0,0,0.05)', height: '100%' }}>
                                            <Box component="img" src={pillar.icon} sx={{ width: 60, height: 60, mb: 2 }} />
                                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#4e429c', mb: 1 }}>{pillar.title}</Typography>
                                            <Typography variant="body2" color="text.secondary">{pillar.desc}</Typography>
                                        </Paper>
                                    </Grid>
                                ))}
                            </Grid>
                        </Container>

                        {/* Solutions Grid */}
                        <Container maxWidth="lg" sx={{ pb: 12 }}>
                            <Grid container spacing={4}>
                                {items.map((item, index) => {
                                    const localIcon = getLocalIcon(item.title);
                                    return (
                                        <Grid item xs={12} sm={6} md={4} key={index}>
                                            <Card sx={{ 
                                                height: '100%', 
                                                display: 'flex', 
                                                flexDirection: 'column',
                                                borderRadius: '16px',
                                                boxShadow: '0 10px 30px rgba(0,0,0,0.03)',
                                                border: '1px solid #eee',
                                                transition: 'all 0.3s ease',
                                                '&:hover': { transform: 'translateY(-5px)', boxShadow: '0 15px 40px rgba(78, 66, 156, 0.1)' }
                                            }}>
                                                <CardContent sx={{ flexGrow: 1, p: 4, textAlign: 'center' }}>
                                                    <Box sx={{ mb: 3, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        {localIcon ? (
                                                            <Box component="img" src={localIcon} sx={{ height: 90, objectFit: 'contain' }} />
                                                        ) : (
                                                            <span className={`icon icon-${item.icon}`} style={{ fontSize: '4rem', color: '#4e429c' }}></span>
                                                        )}
                                                    </Box>
                                                    <Typography variant="h5" sx={{ mb: 2, fontWeight: 700, color: '#4e429c' }}>
                                                        {item.title}
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ color: '#666', mb: 3, lineHeight: 1.6 }}>
                                                        {item.description}
                                                    </Typography>
                                                    <Button 
                                                        component={Link} 
                                                        to={item.link || '#'} 
                                                        variant="contained" 
                                                        sx={{ 
                                                            bgcolor: '#f4b436', 
                                                            '&:hover': { bgcolor: '#e0a12e' },
                                                            borderRadius: '50px',
                                                            px: 4,
                                                            textTransform: 'none',
                                                            fontWeight: 'bold'
                                                        }}
                                                    >
                                                        Saber más
                                                    </Button>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </Container>
                    </Box>
                );
            }}
        />
    );
};

export default SolutionsHub;
